import API from './api'

export default {
	person(id) {
		const api = new API(1, `people/${id}/history`)

		return api.get()
	},
	horse(id) {
		const api = new API(1, `horses/${id}/history`)

		return api.get()
	}
}


// WEBPACK FOOTER //
// ./src/lib/history.js